<div class="filler">
    <VideoOverlay />
</div>

<div class="intro" class:relative={y>window.innerHeight}>
    <Intro />
</div>

<Header />
<Footer />

<Cookies />

<style type="text/scss">
.filler{
    height:200vh;
}
.intro{
    position:fixed;
    width:100%;
    height:100%;
    top:0px;
    &.relative{
        position:relative;
        height:auto;
        margin-top:-100vh;
        /*transform:translateY(-100vh);*/

    }
}
</style>

<script>
import Header from './layouts/Header.svelte'
import Intro from './layouts/Intro.svelte'
import VideoOverlay from './layouts/VideoOverlay.svelte'
import Footer from './layouts/Footer.svelte'
import Cookies from './layouts/Cookies.svelte'

let y = 0
window.addEventListener("scroll", e => {
    y = window.scrollY
}, {passive: true})
</script>